import {ChangeDetectorRef, Inject, Component,} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl, FormsModule} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {Lieferantfragebogen} from "./lieferantfragebogen.model";
import {DatePipe} from "@angular/common";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
// import {Exportfragebogen} from "./Exportfragebogen.model";
import {APIConfigService} from "../../api.config.service";
import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ErrorHelper} from "../../shared/error.helper";
import {CsvConfiguration, Ng2CsvModule, Ng2CsvService} from "ng2csv";
import {Exportfragebogen} from "./exportfragebogen.model";

const PATH_FILE = 'app/protected/fragebogenstatus/fragebogenstatus.component.ts';
const OBJ_LNG_NAME = 'fragebogenstatus';
const BACKEND_PATH_PREFIX = 'fragebogen';

@Component({
    selector: 'oase-fragebogenstatus',
    templateUrl: './fragebogenstatus.component.html',
    styleUrls: ['./fragebogenstatus.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, Ng2CsvModule, FlexModule]

})
export class FragebogenstatusComponent extends Tabelle<Lieferantfragebogen> {

	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	exportFragebogen: Exportfragebogen[] = new Array<Exportfragebogen>();
	statusVon: Date;
	statusBis: Date;
	typen: String[] = new Array<String>();
	statusse: String[] = new Array<String>();
	fragebogennamen: String[] = new Array<String>();
	aktuelleTyp: String = 'Alles';
	aktuelleStatus: String = 'Alles';
	aktuelleFragebogenname: String = 'Alles';

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public ng2CsvService: Ng2CsvService,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService,{
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/fragebogenstatus",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: 'status',
				DEFAULT_SORT_START: 'desc',
				extraDataForAdding: { }
			}
		);

		this.displayedColumns = ['lieferantNummer', 'lieferantName', 'fragebogenName', 'ablaufdatum','typ',
			'status',
			'letzteAenderung',
			'aktion',
		];
		this.getTypen();
		this.getStatusse();
		this.getFragebogennamen();
		this.breadcrumbService.addFriendlyNameForRoute('/protected/fragebogenstatus', this.translation.translate('fragebogen.status2'));
	}

	getApiParams() {
		return "status";
	}

	formQueryString() {
		let queryParts: string[] = [];
		if (this.statusVon != null)
			queryParts.push("von=" + this.datepipe.transform(this.statusVon, 'yyyy-MM-dd'));
		if (this.statusBis != null)
			queryParts.push("bis=" + this.datepipe.transform(this.statusBis, 'yyyy-MM-dd'));
		if (this.aktuelleTyp != null)
			queryParts.push("typ=" + this.aktuelleTyp);
		if (this.aktuelleStatus != null)
			queryParts.push("status=" + this.aktuelleStatus);
		if (this.aktuelleFragebogenname != null)
			queryParts.push("name=" + this.aktuelleFragebogenname);
		return queryParts.join("&");
	}

	private getTypen() {
		this._logger.log(PATH_FILE + ' - getTypen Begin für URL: '+this.REST_API);

		this.http
			.get<String[]>(this.REST_API + '/getFragebogentypen/')
			 // Um mehrfachaufrufe zu verhindern
			.subscribe(
				data => {
					// this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
					this.typen = data;
					this.typen.push('Alles');
					this._logger.log(PATH_FILE + ' - getTypen End', this.typen);
				},
				err => {
					ErrorHelper.handleError(err,"Fehler beim holen der Fragebogentypen",this._logger, this.translation)
				},
				() => {
					this._logger.log(PATH_FILE + ' - Holen der Fragebogentypen abgeschlossen')
				}
			);
	}//getTypen

	private getStatusse() {
		this._logger.log(PATH_FILE + ' - getStatus Begin für URL: '+this.REST_API);

		this.http
			.get<String[]>(this.REST_API + '/getFragebogenstatus/')
			 // Um mehrfachaufrufe zu verhindern
			.subscribe(
				data => {
					// this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
					this.statusse = data;
					this.statusse.push('Alles');
					this._logger.log(PATH_FILE + ' - getStatusse End', this.typen);
				},
				err => {
					ErrorHelper.handleError(err,"Fehler beim holen der Fragebogenstatus",this._logger, this.translation)
				},
				() => {
					this._logger.log(PATH_FILE + ' - Holen der Fragebogenstatus abgeschlossen')
				}
			);
	}//getStatusse

	private getFragebogennamen() {
		this._logger.log(PATH_FILE + ' - getFragebogennamen Begin für URL: '+this.REST_API);

		this.http
			.get<String[]>(this.REST_API + '/getFragebogennamen/')
			 // Um mehrfachaufrufe zu verhindern
			.subscribe(
				data => {
					// this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
					this.fragebogennamen = data;
					this.fragebogennamen.push('Alles');
					this._logger.log(PATH_FILE + ' - getFragebogennamen End', this.typen);
				},
				err => {
					ErrorHelper.handleError(err,"Fehler beim holen der Fragebogennamen",this._logger, this.translation)
				},
				() => {
					this._logger.log(PATH_FILE + ' - Holen der Fragebogennamen abgeschlossen')
				}
			);
	}//getFragebogennamen

	befreieVonPflicht(lieferantfragebogen: Lieferantfragebogen) {
		this._logger.log(PATH_FILE + ' - befreieVonPflicht Begin für URL: '+this.REST_API);

		this.ladedaten = true;
		let lieferantFragebogenNeu: Lieferantfragebogen;

		this.http
			.get<Lieferantfragebogen>(this.REST_API + '/befreieVonPflicht/'+lieferantfragebogen.lieferantId+'/'+lieferantfragebogen.fragebogenId)
			 // Um mehrfachaufrufe zu verhindern
			.subscribe(
				data => {
					// this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
					this.ladedaten = false;
					lieferantFragebogenNeu = data;
					lieferantfragebogen.vonPflichtBefreit = lieferantFragebogenNeu.vonPflichtBefreit;
					this.openSnackBar(this.translation.translate(OBJ_LNG_NAME+'.lieferantBefreit', {liefernummer: lieferantfragebogen.lieferantNummer, fragebogenname: lieferantfragebogen.fragebogenName }));
					this._logger.log(PATH_FILE + ' - befreieVonPflicht End');
					this.dataSource._reloadData.next(true);
				},
				err => {
					this.ladedaten = false;
					ErrorHelper.handleError(err,"Fehler beim befreien von Pflicht",this._logger, this.translation)
				},
				() => {
					this.ladedaten = false;
					this._logger.log(PATH_FILE + ' - Befreien von Pflicht abgeschlossen')
				}
			);
	}//befreieVonPflicht

	bestaetigeFragebogen(lieferantfragebogen: Lieferantfragebogen){
		this._logger.log(PATH_FILE + ' - bestaetigeFragebogen Begin für URL: '+this.REST_API);

		this.ladedaten = true;
		let lieferantFragebogenNeu: Lieferantfragebogen;

		this.http.get<Lieferantfragebogen>(this.REST_API + '/bestaetigeFragebogen/'+lieferantfragebogen.lieferantId+'/'+lieferantfragebogen.fragebogenId)
			 // Um mehrfachaufrufe zu verhindern
			.subscribe(
				data => {
					// this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
					this.ladedaten = false;
					lieferantFragebogenNeu = data;
					lieferantfragebogen.status = lieferantFragebogenNeu.status;
					this._logger.log(PATH_FILE + ' - bestaetigeFragebogen End');
					this.dataSource._reloadData.next(true);
				},
				err => {
					this.ladedaten = false;
					ErrorHelper.handleError(err,"Fehler beim bestätigen des Fragebogens",this._logger, this.translation)
				},
				() => {
					this.ladedaten = false;
					this._logger.log(PATH_FILE + ' - Bestätigen des Fragebogens abgeschlossen')
				}
			);
	}//bestaetigeFragebogen

	export(){
		this._logger.log(PATH_FILE + ' - exportFrageboegen Begin für URL: '+this.REST_API);

		this.ladedaten = true;

		let vonDatum: string = '';
		let bisDatum: string = '';

		if(this.statusVon!=null){
			vonDatum=this.datepipe.transform(this.statusVon, 'yyyy-MM-dd');
		}
		if(this.statusBis!=null){
			bisDatum=this.datepipe.transform(this.statusBis, 'yyyy-MM-dd');
		}

		let request: Observable<Object> = null;
		request = this.http.get(this.REST_API + '/exportFragebogen?von='+vonDatum+'&bis='+bisDatum+'&typ='+this.aktuelleTyp+'&status='+this.aktuelleStatus+'&name='+this.aktuelleFragebogenname);
		request
			 // Um mehrfachaufrufe zu verhindern
			.subscribe({
				next: (data: Exportfragebogen[]) => {
					this.ladedaten = false;
					this.exportFragebogen = data;
					this._logger.log(PATH_FILE + ' - exportFragebogen data = ', this.exportFragebogen);
					let exportHeader: Exportfragebogen = new Exportfragebogen();
					exportHeader.lieferantName = "Lieferantenname";
					exportHeader.lieferantNummer = "Lieferantennummer";
					exportHeader.fragebogenName = "Fragebogenname";
					exportHeader.typ = "Typ";
					exportHeader.ablaufdatum = "Ablaufdatum";
					exportHeader.status = "Status";
					exportHeader.vonPflichtBefreit = "Befreit";
					exportHeader.fragetyp = "Fragetyp";
					exportHeader.fragestellung = "Fragestellung";
					exportHeader.antwort = "Antwort";
					exportHeader.gewaehlt = "Gewählt";
					exportHeader.abgeschlossen = "Abgeschlossen am";
					this.exportFragebogen.unshift(exportHeader);
					const csvConfig = new CsvConfiguration();
					csvConfig.delimiter = ';';
					csvConfig.includeHeaderLine = true;

					this.ng2CsvService.download(this.exportFragebogen, "Frageboegen", undefined, csvConfig );
					this._logger.log(PATH_FILE + ' - exportFrageboegen End');
				},
				error: (err: HttpErrorResponse) => {
					this.ladedaten = false;
					ErrorHelper.handleError(err,"Fehler beim exportieren von Frageboegen",this._logger, this.translation)
				},
				complete: () => {
					this.ladedaten = false;
					this._logger.log(PATH_FILE + ' - Exportieren von Frageboegen abgeschlossen')
				}
    });
	}//export

}

